'use client';

import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { value: '15+', label: 'Years of Experience' },
  { value: '5,000+', label: 'Happy Patients' },
  { value: '3', label: 'Licensed Specialists' },
  { value: '98%', label: 'Patient Satisfaction' },
];

export default function StatsSection() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section data-component-id="src/components/StatsSection.tsx:31:4" data-component-path="src/components/StatsSection.tsx" data-component-line="31" data-component-end-line="62" data-component-file="StatsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%22%7D"
      ref={ref}
      className="py-16"
      style={{ backgroundColor: '#000000' }}
    >
      <div data-component-id="src/components/StatsSection.tsx:36:6" data-component-path="src/components/StatsSection.tsx" data-component-line="36" data-component-end-line="61" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22section-container%22%7D" className="section-container">
        <div data-component-id="src/components/StatsSection.tsx:37:8" data-component-path="src/components/StatsSection.tsx" data-component-line="37" data-component-end-line="60" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20lg%3Agrid-cols-4%20gap-8%22%7D" className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats?.map((stat, idx) => (
            <div data-component-id="src/components/StatsSection.tsx:39:12" data-component-path="src/components/StatsSection.tsx" data-component-line="39" data-component-end-line="58" data-component-file="StatsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              key={idx}
              className={`text-center transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <p data-component-id="src/components/StatsSection.tsx:46:14" data-component-path="src/components/StatsSection.tsx" data-component-line="46" data-component-end-line="51" data-component-file="StatsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20font-bold%20mb-2%22%7D"
                className="text-white font-bold mb-2"
                style={{ fontSize: 'clamp(32px, 4vw, 48px)' }}
              >
                {stat?.value}
              </p>
              <p data-component-id="src/components/StatsSection.tsx:52:14" data-component-path="src/components/StatsSection.tsx" data-component-line="52" data-component-end-line="57" data-component-file="StatsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-gray-400%20uppercase%20tracking-wider%22%7D"
                className="text-gray-400 uppercase tracking-wider"
                style={{ fontSize: '13px', letterSpacing: '0.1em' }}
              >
                {stat?.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
